
const getbyID=(id,colllection)=>{

    return colllection[id['item']]

}



export {getbyID}